"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Panel des Legenden-Moduls
 *
 * @class
 * @extends gc.gis.widget.GCPanel
 * @memberof gc.gis.module.GCLayerTree
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCLayerTree} options.module Modul-Instanz
 * @param {gc.gis.map.GCMapView} options.map={@link gc.gis.GCApplication#map}
 */
gc.gis.module.GCLayerTree.LegendPanel = function (options) {

    // options validierung
    gc.gis.assert.isSet(options);
    gc.gis.assert.isInstance(options.module, gc.gis.module.GCLayerTree);

    // member initialisieren
    this.module = options.module;
    this.map = options.map;

    // content initialisieren
    var options_widget = {
        className: 'gc-layertree-legend'
    };
    gc.gis.widget.GCPanel.call(this, options_widget);

    this.element = this._render();
    this._initContent();
};
gc.gis.module.GCLayerTree.LegendPanel.prototype = Object.create(gc.gis.widget.GCPanel.prototype);

/**
 *
 */
gc.gis.module.GCLayerTree.LegendPanel.prototype._initContent = function () {};

gc.gis.module.GCLayerTree.LegendPanel.prototype.updateList = function ()
{
    this.element_content.empty();

    var accordion = new gc.gis.widget.GCAccordion({
        className: 'gc-layertree-legend-panel'
    });

    var layers = this.map.getReallyVisibleLayers();
    var legend_layers = 0;
    for (var i = layers.length - 1; i >= 0; i--)
    {
        if (layers[i] instanceof gc.gis.layer.GCLayer && layers[i].getShowLegend())
        {
            legend_layers++;
            accordion.addItem(
                'legend_' + i,
                layers[i].getLabel(),
                this.module.createLegendElement(layers[i]),
                {
                    collapsed: true
                }
            );
        }
    }
    if (legend_layers > 0)
    {
        this.element_content.append(accordion.getElement());
    }

    var msg;
    if (layers.length === 0)
    {
        msg = "Keine Ebene aktiviert.";
    }
    else if (legend_layers === 0)
    {
        msg = "Keine Legendengrafik verfügbar für aktuell sichtbare Ebenen.";
    }

    if (msg)
    {
        this.element_content.append(jQuery('<p>', {
            'class': 'gc-empty',
            html: '<em>' + msg + '</em>'
        }));
    }
};
